/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraSoftwareFormAppQuery$parameters';
import type { JiraSoftwareFormAppQuery } from './__generated__/JiraSoftwareFormAppQuery.graphql';

type FormEntrypointComponent = EntryPointComponent<
	{
		formQuery: JiraSoftwareFormAppQuery;
	},
	{},
	{},
	{}
>;

export const formEntrypoint: EntryPoint<FormEntrypointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<FormEntrypointComponent>(
			/* webpackChunkName: "async-software-form-entrypoint" */ './JiraSoftwareFormApp.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
			const projectKey = context.match.params.projectKey;

			if (projectKey == null) {
				throw new Error('Project key missing');
			}

			return {
				queries: {
					formQuery: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters,
						variables: {
							cloudId,
							projectKey,
						},
					},
				},
			};
		},
	});
